export enum LiquidityPoolStatusEnum {
  InRange = 1,
  OutOfRange = 2,
  Closed = 3
}

export const LiquidityPoolStatusLabel: Record<LiquidityPoolStatusEnum, string> = {
  [LiquidityPoolStatusEnum.InRange]: 'In Range',
  [LiquidityPoolStatusEnum.OutOfRange]: 'Out of Range',
  [LiquidityPoolStatusEnum.Closed]: 'Closed',
};
